import React from 'react';
import { motion } from 'framer-motion';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
import { CheckIcon, GlobeIcon, UsersIcon, BuildingIcon, ArrowRightIcon } from 'lucide-react';
const partners = [{
  name: "Chambre de Commerce et d'Industrie France-Afrique",
  logo: 'https://via.placeholder.com/200x100?text=CCI+France-Afrique',
  description: "Partenaire institutionnel facilitant les relations commerciales entre la France et l'Afrique.",
  type: 'Institutionnel'
}, {
  name: 'African Development Bank',
  logo: 'https://via.placeholder.com/200x100?text=AfDB',
  description: "Collaboration sur les projets financés et les appels d'offres internationaux.",
  type: 'Financier'
}, {
  name: 'Business France',
  logo: 'https://via.placeholder.com/200x100?text=Business+France',
  description: "Partenariat stratégique pour l'accompagnement des entreprises françaises en Afrique.",
  type: 'Institutionnel'
}, {
  name: 'Tunipages Group',
  logo: 'https://via.placeholder.com/200x100?text=Tunipages',
  description: "Partenaire technique pour l'Afrique du Nord, spécialiste des données d'entreprises.",
  type: 'Technique'
}, {
  name: 'Kenya Association of Manufacturers',
  logo: 'https://via.placeholder.com/200x100?text=KAM',
  description: "Partenariat stratégique pour le développement d'affaires en Afrique de l'Est.",
  type: 'Sectoriel'
}, {
  name: "CGECI - Confédération Générale des Entreprises de Côte d'Ivoire",
  logo: 'https://via.placeholder.com/200x100?text=CGECI',
  description: "Collaboration privilégiée pour les marchés d'Afrique de l'Ouest francophone.",
  type: 'Institutionnel'
}, {
  name: 'Agence Française de Développement',
  logo: 'https://via.placeholder.com/200x100?text=AFD',
  description: 'Partenariat sur les projets de développement financés par la France en Afrique.',
  type: 'Financier'
}, {
  name: 'Data Ventures SA',
  logo: 'https://via.placeholder.com/200x100?text=Data+Ventures',
  description: "Partenaire technologique pour l'analyse de données et l'intelligence artificielle.",
  type: 'Technique'
}];
const partnershipBenefits = [{
  title: 'Visibilité internationale',
  description: "Profitez d'une exposition auprès de notre réseau d'entreprises françaises et européennes.",
  icon: <GlobeIcon className="h-6 w-6 text-blue-600" data-id="element-2767" />
}, {
  title: "Réseau d'affaires",
  description: 'Accédez à notre communauté de plus de 500 entreprises actives sur les marchés africains.',
  icon: <UsersIcon className="h-6 w-6 text-blue-600" data-id="element-2768" />
}, {
  title: 'Opportunités commerciales',
  description: "Développez de nouvelles relations d'affaires et identifiez des synergies potentielles.",
  icon: <BuildingIcon className="h-6 w-6 text-blue-600" data-id="element-2769" />
}];
export function PartnersPage() {
  return <div className="min-h-screen bg-white text-gray-900 font-sans" data-id="element-2770">
      <Navbar data-id="element-2771" />
      <main className="pt-20" data-id="element-2772">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-20 relative overflow-hidden" data-id="element-2773">
          {/* Background pattern */}
          <div className="absolute inset-0 opacity-10" data-id="element-2774">
            <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-2775">
              <defs data-id="element-2776">
                <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-2777">
                  <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" strokeWidth="1" data-id="element-2778" />
                </pattern>
              </defs>
              <rect width="100%" height="100%" fill="url(#grid)" data-id="element-2779" />
            </svg>
          </div>
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-1/3 h-1/3 bg-blue-800 rounded-full opacity-30 transform translate-x-1/3 -translate-y-1/3" data-id="element-2780"></div>
          <div className="absolute bottom-0 left-0 w-1/4 h-1/4 bg-yellow-500 rounded-full opacity-20 transform -translate-x-1/3 translate-y-1/3" data-id="element-2781"></div>
          <div className="container mx-auto px-4 relative z-10" data-id="element-2782">
            <div className="max-w-3xl mx-auto text-center" data-id="element-2783">
              <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-2784">
                Nos Partenaires
              </h1>
              <p className="text-xl text-blue-100 mb-8" data-id="element-2785">
                Un réseau d'acteurs de premier plan pour vous offrir un
                accompagnement complet sur les marchés africains.
              </p>
            </div>
          </div>
        </section>
        {/* Partnership Approach Section */}
        <section className="py-20 bg-blue-50" data-id="element-2786">
          <div className="container mx-auto px-4" data-id="element-2787">
            <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-2788">
              <span className="inline-block px-3 py-1 bg-blue-100 text-blue-900 text-sm font-semibold rounded-full mb-4" data-id="element-2789">
                Notre Approche
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-6" data-id="element-2790">
                Une approche collaborative et panafricaine
              </h2>
              <p className="text-lg text-gray-700" data-id="element-2791">
                Nous avons développé un réseau de partenaires dans toute
                l'Afrique pour garantir une information fiable et un
                accompagnement de qualité, quel que soit votre secteur
                d'activité ou votre pays cible.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center max-w-5xl mx-auto" data-id="element-2792">
              <motion.div initial={{
              opacity: 0,
              x: -30
            }} whileInView={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.5
            }} viewport={{
              once: true
            }} data-id="element-2793">
                <img src="https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="Partenaires en réunion" className="rounded-lg shadow-lg w-full h-auto" data-id="element-2794" />
              </motion.div>
              <motion.div initial={{
              opacity: 0,
              x: 30
            }} whileInView={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.5
            }} viewport={{
              once: true
            }} data-id="element-2795">
                <h3 className="text-2xl font-bold text-blue-900 mb-6" data-id="element-2796">
                  Un réseau panafricain
                </h3>
                <ul className="space-y-4" data-id="element-2797">
                  {['Partenaires institutionnels dans plus de 30 pays africains', 'Collaborations avec les principales chambres de commerce locales', 'Partenariats avec des institutions financières de développement', 'Experts sectoriels dans chaque région du continent'].map((item, index) => <li key={index} className="flex items-start" data-id="element-2798">
                      <div className="mr-3 mt-1 flex-shrink-0" data-id="element-2799">
                        <div className="w-5 h-5 bg-green-100 rounded-full flex items-center justify-center" data-id="element-2800">
                          <CheckIcon size={12} className="text-green-600" data-id="element-2801" />
                        </div>
                      </div>
                      <span className="text-gray-700" data-id="element-2802">{item}</span>
                    </li>)}
                </ul>
                <div className="mt-8" data-id="element-2803">
                  <Button variant="secondary" className="flex items-center" data-id="element-2804">
                    <span data-id="element-2805">En savoir plus sur notre réseau</span>
                    <ArrowRightIcon size={16} className="ml-2" data-id="element-2806" />
                  </Button>
                </div>
              </motion.div>
            </div>
          </div>
        </section>
        {/* Partners Grid Section */}
        <section className="py-20" data-id="element-2807">
          <div className="container mx-auto px-4" data-id="element-2808">
            <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-2809">
              <span className="inline-block px-3 py-1 bg-blue-50 text-blue-900 text-sm font-semibold rounded-full mb-4" data-id="element-2810">
                Nos Partenaires
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-6" data-id="element-2811">
                Ils nous font confiance
              </h2>
              <p className="text-lg text-gray-700" data-id="element-2812">
                Découvrez les organisations qui collaborent avec nous pour
                faciliter votre développement en Afrique.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-2813">
              {partners.map((partner, index) => <motion.div key={partner.name} className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-100 transition-transform hover:-translate-y-1 hover:shadow-lg" initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} viewport={{
              once: true
            }} data-id="element-2814">
                  <div className="h-32 bg-gray-50 flex items-center justify-center p-4" data-id="element-2815">
                    <img src={partner.logo} alt={partner.name} className="max-h-full max-w-full object-contain" data-id="element-2816" />
                  </div>
                  <div className="p-4" data-id="element-2817">
                    <div className="inline-block px-2 py-1 bg-blue-50 text-blue-700 text-xs font-medium rounded-full mb-2" data-id="element-2818">
                      {partner.type}
                    </div>
                    <h3 className="text-lg font-semibold text-blue-900 mb-2" data-id="element-2819">
                      {partner.name}
                    </h3>
                    <p className="text-sm text-gray-600" data-id="element-2820">
                      {partner.description}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </section>
        {/* Become a Partner Section */}
        <section className="py-20 bg-blue-50" data-id="element-2821">
          <div className="container mx-auto px-4" data-id="element-2822">
            <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-2823">
              <span className="inline-block px-3 py-1 bg-blue-100 text-blue-900 text-sm font-semibold rounded-full mb-4" data-id="element-2824">
                Collaboration
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-6" data-id="element-2825">
                Devenez partenaire d'ElevateIT
              </h2>
              <p className="text-lg text-gray-700" data-id="element-2826">
                Vous êtes une organisation active en Afrique ? Rejoignez notre
                réseau de partenaires et développons ensemble des synergies pour
                accompagner les entreprises françaises.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto mb-12" data-id="element-2827">
              {partnershipBenefits.map((benefit, index) => <motion.div key={benefit.title} className="bg-white p-6 rounded-xl shadow-md" initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: index * 0.2
            }} viewport={{
              once: true
            }} data-id="element-2828">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4" data-id="element-2829">
                    {benefit.icon}
                  </div>
                  <h3 className="text-xl font-semibold text-blue-900 mb-3" data-id="element-2830">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-700" data-id="element-2831">{benefit.description}</p>
                </motion.div>)}
            </div>
            <div className="text-center" data-id="element-2832">
              <Button variant="primary" size="lg" className="shadow-lg shadow-yellow-500/20" data-id="element-2833">
                Devenir partenaire
              </Button>
            </div>
          </div>
        </section>
        {/* Testimonials Section */}
        <section className="py-20 bg-white" data-id="element-2834">
          <div className="container mx-auto px-4" data-id="element-2835">
            <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-2836">
              <span className="inline-block px-3 py-1 bg-blue-50 text-blue-900 text-sm font-semibold rounded-full mb-4" data-id="element-2837">
                Témoignages
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-6" data-id="element-2838">
                Ce que nos partenaires disent
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-2839">
              <motion.div className="bg-white p-6 rounded-xl shadow-md border border-gray-100" initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.5
            }} viewport={{
              once: true
            }} data-id="element-2840">
                <div className="flex items-center mb-4" data-id="element-2841">
                  <div className="w-12 h-12 rounded-full overflow-hidden mr-4" data-id="element-2842">
                    <img src="https://randomuser.me/api/portraits/men/92.jpg" alt="Amadou Diallo" className="w-full h-full object-cover" data-id="element-2843" />
                  </div>
                  <div data-id="element-2844">
                    <h4 className="font-semibold text-blue-900" data-id="element-2845">
                      Amadou Diallo
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-2846">
                      Directeur, Chambre de Commerce Sénégal-France
                    </p>
                  </div>
                </div>
                <blockquote className="text-gray-700 italic" data-id="element-2847">
                  "Notre partenariat avec ElevateIT nous a permis de connecter
                  efficacement les entreprises françaises avec les opportunités
                  au Sénégal. Une collaboration fructueuse qui valorise
                  l'expertise locale."
                </blockquote>
              </motion.div>
              <motion.div className="bg-white p-6 rounded-xl shadow-md border border-gray-100" initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.5
            }} viewport={{
              once: true
            }} data-id="element-2848">
                <div className="flex items-center mb-4" data-id="element-2849">
                  <div className="w-12 h-12 rounded-full overflow-hidden mr-4" data-id="element-2850">
                    <img src="https://randomuser.me/api/portraits/women/68.jpg" alt="Sarah Kimani" className="w-full h-full object-cover" data-id="element-2851" />
                  </div>
                  <div data-id="element-2852">
                    <h4 className="font-semibold text-blue-900" data-id="element-2853">
                      Sarah Kimani
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-2854">
                      Directrice des Relations Internationales, KAM
                    </p>
                  </div>
                </div>
                <blockquote className="text-gray-700 italic" data-id="element-2855">
                  "Grâce à notre partenariat avec ElevateIT, nous avons pu
                  faciliter l'implantation de plusieurs entreprises françaises
                  au Kenya. Leur approche professionnelle et leur connaissance
                  du marché font toute la différence."
                </blockquote>
              </motion.div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-2856" />
    </div>;
}